import { Alert, AlertDescription, AlertIcon, Button, HStack, Text } from '@chakra-ui/react'
import type { ChildTicketTask } from '@/lib/services/childTicketService'
import { findTaskByPanelType } from './taskUtils'

type Props = {
  tasks: ChildTicketTask[]
  storeId?: number | null
  assetsCount?: number
  onOpenTask: (task: ChildTicketTask) => void
}

export default function TasksOperationalBanner({
  tasks,
  storeId,
  assetsCount = 0,
  onOpenTask,
}: Props) {
  const needsStore = storeId == null
  const needsAssets = assetsCount === 0
  if (!needsStore && !needsAssets) return null

  const feTask = findTaskByPanelType(tasks, 'fe')
  const assetsTask = findTaskByPanelType(tasks, 'assets')

  return (
    <Alert status="info" borderRadius="md" mb={4} bg="blue.50" border="1px solid" borderColor="blue.200">
      <AlertIcon />
      <AlertDescription fontSize="sm" flex="1">
        <Text mb={2}>
          {needsStore && needsAssets
            ? 'Link the store and equipment on the tasks below (removed from the create form).'
            : needsStore
              ? 'Link the store on the plotting task before dispatching from the parent ticket.'
              : 'Add equipment on the CSO Review task.'}
        </Text>
        <HStack spacing={2} flexWrap="wrap">
          {needsStore && feTask ? (
            <Button size="xs" colorScheme="orange" variant="outline" onClick={() => onOpenTask(feTask)}>
              Open {feTask.title ?? 'FE Plotting'}
            </Button>
          ) : null}
          {needsAssets && assetsTask ? (
            <Button size="xs" colorScheme="purple" variant="outline" onClick={() => onOpenTask(assetsTask)}>
              Open {assetsTask.title ?? 'CSO Review'}
            </Button>
          ) : null}
        </HStack>
      </AlertDescription>
    </Alert>
  )
}
